import { RadioGroup } from "components/Atoms/inputs/RadioGroup";
import { getMaritalStatus } from "contact/detail/components/MaritalStatusRow";
import React from "react";

interface Props {
  value: server.dto.MaritalStatuses;
  onChange: (value: server.dto.MaritalStatuses) => void;
}

export const MaritalStatusRadio = (props: Props) => {
  return <RadioGroup
    orientation="vertical"
    options={[
      { label: getMaritalStatus("unknown"), value: "unknown" satisfies server.dto.MaritalStatuses },
      { label: getMaritalStatus("neverMarried"), value: "neverMarried" satisfies server.dto.MaritalStatuses },
      { label: getMaritalStatus("married"), value: "married" satisfies server.dto.MaritalStatuses },
      { label: getMaritalStatus("divorced"), value: "divorced" satisfies server.dto.MaritalStatuses },
      { label: getMaritalStatus("widowed"), value: "widowed" satisfies server.dto.MaritalStatuses }
    ]}
    value={props.value}
    onChange={props.onChange}
  />
}